import {
  currencyString,
  formatDate,
  isDefined,
  isFullPayoffPayment,
  isPaymentAmountLessThanDueAmount,
  isPaymentOnOrBeforeNextDueDate,
  presentableProductType,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessagePartialPaymentNonAutopay: UseMessageT = (props) => {
  const {
    dueAmount,
    dueDate,
    fullPayoffAmount,
    isAutopay,
    isFullPayoffDisabled,
    isNextMinimumPaymentDisabled,
    loanStatus,
    originalDueAmount,
    paymentAmount,
    paymentDate,
    productType,
    scheduledAmount,
  } = props;

  if (!isDefined(dueAmount)
    || !isDefined(dueDate)
    || !isDefined(fullPayoffAmount)
    || !isDefined(isAutopay)
    || !isDefined(isFullPayoffDisabled)
    || !isDefined(isNextMinimumPaymentDisabled)
    || !isDefined(loanStatus)
    || !isDefined(originalDueAmount)
    || !isDefined(paymentAmount)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
  ) { return undefined; }

  const isCurrent = loanStatus === 'current';

  const fullPayoffProps = {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  };

  const hasRemainingBalance = dueAmount < originalDueAmount;
  const partialDueAmount = dueAmount - paymentAmount;

  // NCFE-10082 (C-2)
  if (isCurrent
    && !isAutopay
    && !isFullPayoffPayment(fullPayoffProps)
    && isPaymentOnOrBeforeNextDueDate(paymentDate, dueDate)
    && isPaymentAmountLessThanDueAmount(dueAmount, paymentAmount)
    && (dueAmount === scheduledAmount)
    && !isNextMinimumPaymentDisabled
  ) {
    return (
      <>
        <p>
          This payment will{' '}
          <span className="fw-bold">
            apply toward your {presentableProductType(productType)}
          </span>{' '}
          of {currencyString(dueAmount)}{hasRemainingBalance && ' remaining'}{' '}
          due on {formatDate(dueDate)}.
        </p>
        <p className="mt-2">
          The remaining{' '}
          <span className="fw-bold">
            {currencyString(partialDueAmount)} is still due
          </span>{' '}
          on {formatDate(dueDate)}.
        </p>
      </>
    );
  }

  return undefined;
};
